import { ChartProps } from '@superset-ui/core';
import { FilterSelectorFormData } from './types';

function parseDatasourceString(ds: any): { id?: number; type?: string } {
  if (typeof ds === 'string' && ds.includes('__')) {
    const [idStr, type] = ds.split('__');
    const id = Number(idStr);
    return { id: Number.isFinite(id) ? id : undefined, type };
  }
  if (ds?.id && ds?.type) return { id: Number(ds.id), type: String(ds.type) };
  return {};
}

export default function transformProps(chartProps: ChartProps) {
  const { width, height, formData, hooks, datasource, ownState } = chartProps;
  const { setDataMask = () => {} } = hooks ?? {};

  const { id: datasourceId, type: datasourceType } = parseDatasourceString((formData as any).datasource);

  const emitCrossFilters = Boolean(
    (formData as any).emitCrossFilters ?? (formData as any).emit_cross_filters,
  );

  return {
    width,
    height,
    formData: formData as FilterSelectorFormData,
    datasource,
    datasourceId,
    datasourceType,
    setDataMask,
    emitCrossFilters,
    ownState,
  };
}

